export default {
  nodes: [],
  links: [],
  showMenu: false,
  selected: {},
  showSelection: false,
  linksSelected: {},
  options: {
    canvas: false,
    size: {
      w: 500,
      h: 500
    },
    force: 350,
    offset: {
      x: 0,
      y: 0
    },
    nodeSize: 20,
    linkWidth: 1,
    nodeLabels: false,
    linkLabels: false,
    strLinks: true
  }
}
